module.exports = __webpack_public_path__ + "static/media/login-logo.fa1ff4ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/login-logo.png
// module id = 116
// module chunks = 0